class InputValueAdderComponent extends Component
{

    component_interface;

    constructor() {
        super(InputValueAdderComponent, '.input_value_adder_component');
        this.component_interface = null
        this.registerListeners();
    }



    registerListeners() {
        super.registerListeners();

        let value_adder_button_listener = new ValueAdderButtonListener(
            '.input_value_adder_button',
            this.component_interface
        );


        let value_adder_reset_button_listener = new ValueAdderResetListener(
            '.input_value_adder_reset_button',
            this.component_interface
        );

    }


}

$(document).ready(function (e){
    Components.addComponent(
        new InputValueAdderComponent()
    );
});

